import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../firebase';

export default function AdminLogin() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [showPw, setShowPw]     = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) { setError('Please enter email and password.'); return; }
    setLoading(true);
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError('Invalid email or password. Please try again.');
    }
    setLoading(false);
  };

  const inp = {
    width: '100%', padding: '12px 14px',
    background: 'rgba(255,255,255,0.07)',
    border: '1px solid rgba(255,255,255,0.12)',
    borderRadius: '6px', color: 'white',
    fontSize: '0.9rem', fontFamily: 'Jost,sans-serif',
    outline: 'none', boxSizing: 'border-box',
  };

  return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(155deg,#060E1E 0%,#0B1D3A 60%,#122B52 100%)', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'Jost,sans-serif', padding:'20px' }}>
      <div style={{ width:'100%', maxWidth:'420px' }}>
        {/* Logo */}
        <div style={{ textAlign:'center', marginBottom:'36px' }}>
          <div style={{ width:'68px', height:'68px', background:'white', borderRadius:'50%', overflow:'hidden', margin:'0 auto 14px', padding:'4px' }}>
            <img src="/images/logo.jpg" alt="Eye-Sight" style={{ width:'100%', objectFit:'contain' }} />
          </div>
          <h1 style={{ fontFamily:'Cormorant Garamond,serif', fontSize:'1.8rem', fontWeight:700, color:'white', margin:'0 0 4px' }}>Admin Portal</h1>
          <p style={{ color:'rgba(255,255,255,0.35)', fontSize:'0.75rem', letterSpacing:'0.15em', textTransform:'uppercase', margin:0 }}>Eye-Sight Care &amp; Optical</p>
        </div>

        {/* Card */}
        <div style={{ background:'rgba(255,255,255,0.05)', backdropFilter:'blur(20px)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:'10px', padding:'36px' }}>
          <h2 style={{ fontFamily:'Cormorant Garamond,serif', fontSize:'1.4rem', fontWeight:600, color:'white', marginBottom:'24px', marginTop:0 }}>Sign In</h2>

          {error && (
            <div style={{ background:'rgba(220,38,38,0.15)', border:'1px solid rgba(220,38,38,0.3)', borderRadius:'6px', padding:'12px 16px', marginBottom:'18px', color:'#FCA5A5', fontSize:'0.84rem' }}>
              {error}
            </div>
          )}

          <form onSubmit={handleLogin}>
            <div style={{ marginBottom:'14px' }}>
              <label style={{ fontSize:'0.7rem', color:'rgba(255,255,255,0.4)', letterSpacing:'0.12em', textTransform:'uppercase', display:'block', marginBottom:'6px' }}>Email Address</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="admin@eyesight.com" style={inp} />
            </div>

            <div style={{ marginBottom:'22px' }}>
              <label style={{ fontSize:'0.7rem', color:'rgba(255,255,255,0.4)', letterSpacing:'0.12em', textTransform:'uppercase', display:'block', marginBottom:'6px' }}>Password</label>
              <div style={{ position:'relative' }}>
                <input type={showPw ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" style={{ ...inp, paddingRight:'44px' }} />
                <button type="button" onClick={() => setShowPw(!showPw)} style={{ position:'absolute', right:'12px', top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'rgba(255,255,255,0.4)', fontSize:'0.8rem', fontFamily:'Jost,sans-serif' }}>
                  {showPw ? 'Hide' : 'Show'}
                </button>
              </div>
            </div>

            <button type="submit" disabled={loading} style={{ width:'100%', padding:'13px', background: loading ? 'rgba(200,169,110,0.5)' : 'linear-gradient(135deg,#C8A96E,#B8935A)', color:'#0B1D3A', border:'none', cursor: loading ? 'default' : 'pointer', borderRadius:'6px', fontSize:'0.8rem', fontWeight:700, letterSpacing:'0.14em', textTransform:'uppercase', fontFamily:'Jost,sans-serif' }}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <p style={{ marginTop:'18px', fontSize:'0.72rem', color:'rgba(255,255,255,0.2)', textAlign:'center', margin:'18px 0 0' }}>
            Restricted to authorised administrators only.
          </p>
        </div>

        <p style={{ textAlign:'center', marginTop:'20px', fontSize:'0.72rem', color:'rgba(255,255,255,0.2)' }}>
          Powered by <span style={{ color:'#C8A96E' }}>TechTide Stratum</span>
        </p>
      </div>
    </div>
  );
}
